import { render, staticRenderFns } from "./AnnouncementsList.vue?vue&type=template&id=37b28637"
import script from "./AnnouncementsList.vue?vue&type=script&lang=js"
export * from "./AnnouncementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports